import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { DatePipe } from '@angular/common';

const BIRTHDAY_PATTERN = /^(\d{2})\/(\d{2})\/((19\d{2})|(2\d{3}))$/;

@Directive({
    selector: '[jhiBirthDate][ngModel]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: BirthDateValidatorDirective, multi: true }
    ]
})
export class BirthDateValidatorDirective implements Validator {

    constructor(private datePipe: DatePipe) {

    }

    validate(c: AbstractControl): { [key: string]: any; } {
        if (!c.value) {
            return null;
        }

        try {
            if (!this.datePipe.transform(c.value, 'dd/MM/yyyy').match(BIRTHDAY_PATTERN)) {
                return { 'invalid-birth-date': true };
            }

            if (this.isGreaterThanToday(c.value)) {
                return { 'birth-date-gt-currentday': true };
            }

        } catch (e) {
            return { 'invalid-birth-date': true };
        }

        return null;
    }

    protected isGreaterThanToday(birthday: string): boolean {
        let currentDate = new Date();
        let date = new Date(birthday);
        return date > currentDate;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/forms/validators/birthdate-validator.ts